import { Blister, PointOfInterest } from '@/__generated__/graphql';

// Typed against the generated GraphQL types — TypeScript will error on invalid keys.
// To expose a new POI/Blister field in the review panel template builder, add it here.

const BLISTER_FIELD_LABELS: Partial<Record<keyof Blister, string>> = {
  maxHeight: 'Blister Height / Pit Depth',
  estimatedHeight: 'Estimated Height',
  manualSetHeight: 'Manual Set Height',
  blisterHeightIndex: 'Blister Height Index',
  pdrHeight: 'PDR Height',
  heightType: 'Calculation Method',
  verifiedMaxHeight: 'Verified Height',
  wallLoss: 'Estimated Wall Loss',
  residualCorrosionAllowance: 'Residual Corrosion Allowance',
  residualThickness: 'Residual Thickness',
  verifiedResidualThickness: 'Verified Residual Thickness',
  measurementConfidence: 'Measurement Confidence',
  distanceConfidence: 'Distance Confidence',
};

// Keys handled by the resolver's switch statement that are not direct fields
// on the Blister GraphQL type (e.g. derived values or not yet in schema).
const BLISTER_RESOLVER_ALIAS_FIELDS: { key: string; name: string }[] = [
  { key: 'verifiedResidualCorrosionAllowance', name: 'Verified Residual Corrosion Allowance' },
];

const POI_FIELD_LABELS: Partial<Record<keyof PointOfInterest, string>> = {
  deckRelativeHeight: 'Height from Deck',
  paintRegion: 'Paint Block',
  status: 'Status',
  assembly: 'Component',
  assignee: 'Assigned To',
  visibility: 'Access Control',
  workpack: 'Workpack',
  accessibility: 'Accessibility',
  viewpointRelativeHeight: 'POI Height from Viewpoint',
};

// Keys handled by the resolver that are not direct fields on the PointOfInterest
// GraphQL type (e.g. `deckName` is from paintRegion.deck.name, `createdBy` is from createdByUser).
const POI_RESOLVER_ALIAS_FIELDS: { key: string; name: string }[] = [
  { key: 'deckName', name: 'Deck Name' },
  { key: 'createdBy', name: 'Created By' },
];

export const REVIEW_PANEL_BLISTER_FIELDS: { key: string; name: string }[] = [
  ...(Object.entries(BLISTER_FIELD_LABELS) as [keyof Blister, string][]).map(([key, name]) => ({
    key: key as string,
    name,
  })),
  ...BLISTER_RESOLVER_ALIAS_FIELDS,
];

export const REVIEW_PANEL_POI_FIELDS: { key: string; name: string }[] = [
  ...(Object.entries(POI_FIELD_LABELS) as [keyof PointOfInterest, string][]).map(([key, name]) => ({
    key: key as string,
    name,
  })),
  ...POI_RESOLVER_ALIAS_FIELDS,
];
